<template>
  <VueDraggableResizable
    :y="70"
    :x="x"
    :w="w"
    :h="84"
    :resizable="false"
    :draggable="!isMobile"
    parent="#app"
    class-name="temperature-wrapper"
  >
    <ButtonBar
      class="m-2"
      light
      @minimize="open = false"
      @maximize="open = true"
    />
    <div class="temperature-container">
      <div class="flex items-start p-2">
        <div class="bg-blue p-2 text-blue-lighter whitespace-no-wrap mr-4">{{ selected }}º C</div>
        <div class="temperature-title">
          <div>TEMPERATURE.GAUGE</div>
          <div class="hidden sm:block">20304.39943.22 V2//{0002}//23.2</div>
        </div>
      </div>
      <div v-if="open">
        <div
          v-for="temperature in temperatures"
          :key="temperature.value"
          class="temperature-item"
          :class="{ selected: temperature.value === selected }"
          @click="selected = temperature.value"
        >
          >>{{ temperature.name }}
        </div>
      </div>
    </div>
  </VueDraggableResizable>
</template>

<script>
import { mapGetters } from 'vuex'
import VueDraggableResizable from 'vue-draggable-resizable'
import ButtonBar from './ButtonBar.vue'

export default {
  name: 'TemperatureGauge',

  components: {
    ButtonBar,
    VueDraggableResizable,
  },

  data() {
    return {
      open: false,
      selected: 29,
      temperatures: [
        { name: 'INTERNAL.TEMP_GENERATOR', value: 35 },
        { name: 'INTERNAL.TEMP_LIVING.QUARTERS', value: 23 },
        { name: 'INTERNAL.TEMP_BOTANY.LAB', value: 30 },
        { name: 'INTERNAL.TEMP_IMMUNOLOGY.LAB', value: 18 },
        { name: 'INTERNAL.TEMP_CANTEEN', value: 24 },
        { name: 'INTERNAL.TEMP_SERVER.ROOM', value: 22 },
        { name: 'INTERNAL.TEMP_WATER.TREATMENT', value: 29 },
      ],
    }
  },

  computed: {
    ...mapGetters({
      x: 'global/temperatureX',
      w: 'global/temperatureWidth',
      isMobile: 'global/isMobile',
    }),
  },
}
</script>

<style lang="postcss" scoped>
.temperature {
  &-wrapper {
    z-index: 8 !important;
  }

  &-container {
    font-family: 'input-mono';
    @apply border border-blue text-blue p-4 bg-almost-black;
  }

  &-title {
    font-size: 12px;
    @apply whitespace-no-wrap mr-4;
  }

  &-item {
    font-size: 14px;
    @apply p-2 cursor-pointer;

    &.selected,
    &:hover {
      @apply bg-blue text-blue-lightest;
    }
  }
}
</style>
